import { render, staticRenderFns } from "./FncAdmin.vue?vue&type=template&id=2021834e"
import script from "./FncAdmin.vue?vue&type=script&lang=js"
export * from "./FncAdmin.vue?vue&type=script&lang=js"
import style0 from "./FncAdmin.vue?vue&type=style&index=0&id=2021834e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports